import { styled, keyframes } from '@mui/material';
import { IconSpikes } from '../../internal/icons';
const rotate = keyframes `
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const IconLoading = styled(IconSpikes) `
  animation: ${rotate} 1s steps(8, end) infinite;
`;
export default IconLoading;
